import { SelectorListContext } from '@angular/compiler';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { HomeService } from 'src/app/_services/home.service';
import { ProjectService } from 'src/app/_services/project.service';
import { UserMgmtService } from 'src/app/_services/user-mgmt.service';
import { beatBlipSubscriptionConsts } from 'src/app/consts/beatBlipSubscriptionConsts';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-account-management',
  templateUrl: './account-management.component.html',
  styleUrls: ['./account-management.component.scss']
})
export class AccountManagementComponent implements OnInit {

  @ViewChild('closeAddUserForm', null) closeAddUserForm: ElementRef;
  @ViewChild('closeUserAccessForm', null) closeUserAccessForm: ElementRef;
  @ViewChild('cancelprojectAccess', null) cancelprojectAccess: ElementRef;
  @ViewChild('cancelRcAccess', null) cancelRcAccess: ElementRef;
  @ViewChild('cancelwfAccess', null) cancelwfAccess: ElementRef;
  addUserForm: UntypedFormGroup;
  editUserForm: UntypedFormGroup;
  showEditForm: boolean = false;
  masterUsers: any = [];
  projectList: any = [];
  editProjectAccessList: any = [];
  selectedProfile: any;
  selectedUserId : string;
  editUserIndex: number;
  selectedUser: string;
  searchProject: string;
  searchWf:any;
  loadProjectList : boolean = false;
  oldUser : boolean = false;
  currentUserDetails: any;
  enableCreateUser: boolean = false;
  enableEditUser: boolean = false;
  userManagementData: any = {};
  headerOptions = {
    showSetting : false,
    showSearch: false,
    heading : 'Account Management',
    data: undefined,
  }
  domainCheck: boolean;
  pagesSize = beatBlipSubscriptionConsts.pagesSize;
  perpageitem = beatBlipSubscriptionConsts.perpageitem;
  selectedPage: any;
  wabCheck :any;
  sortDir: number;
  rcResponse: any;
  rcCategoryList: any[];
  allComponent: any=[];
  userData: any;
  masterUsersCopy: any;
  searchString: string = '';
  selectAllView : boolean = true;
  selectAllEdit : boolean = true;
  selectAllDelete : boolean = true;
  selectAllExecute : boolean = true;
  allComponentCopy: any;
  workFlowList:any;
  // workFlowList: any = [
  //   {
  //     workflowId: "C6791d73ecc6ddb6b7d2b684e",
  //     name: "Manage Credit score",
  //     view: true,
  //     delete: true,
  //     desabled: true,
  //     edit: true,
  //     execute: true
  //   },
  //   {
  //     workflowId: "B6791d73ecc6ddb6b7d2b685e",
  //     name: "Loan application",
  //     view: true,
  //     delete: true,
  //     desabled: false,
  //     edit: true,
  //     execute: false
  //   },
  //   {
  //     workflowId: "A6791d73ecc6ddb6b7d2b686e",
  //     name: "Ticket booking",
  //     view: true,
  //     delete: true,
  //     desabled: false,
  //     edit: false,
  //     execute: true
  //   },
  //   {
  //     workflowId: "A6791d73ecc6ddb6b7d2b686e",
  //     name: "Hiring Process",
  //     view: true,
  //     delete: true,
  //     desabled: false,
  //     edit: false,
  //     execute: true
  //   }
  // ];
  enablewf: boolean = false;
  wfAccessBodyCopy: any;
  selectAllViewwf: any;
  selectAllDeletewf: any;
  selectAllEditwf: any;
  selectAllExecutewf: any;
  focusedField: string | null = null;

  constructor(
    private readonly userManagement: UserMgmtService,
    private readonly fb: UntypedFormBuilder,
    private readonly homeService: HomeService,
    private readonly toastrService: ToastrService,
    private readonly project: ProjectService) {

      this.domainCheck = localStorage.getItem('isADOEnabled') == 'true' ? true : false;
      this.wabCheck = environment.okta;
  }
  onPageChange(newValue) {
    this.selectedPage = newValue;
    this.perpageitem = newValue;
  }
  ngOnInit() {
    this.loadfeatureflag();
    this.initAllForms();
    this.loadUsers();
    //set header details
    this.homeService.setHeaderOptions(this.headerOptions);
  }

  initAllForms() {
    this.initAddUserForm();
    this.initEditUserForm();
  }

  initAddUserForm() {
    this.addUserForm = this.fb.group({
      id: [''],
      name: ['', [Validators.required, Validators.maxLength(50)]],
      // email: ['', [Validators.required, Validators.email]],
      email: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/)]],
      password: ['', [Validators.required, Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&^()])[A-Za-z\d@$!%*#?&^()]{8,20}$/)]],
      phone: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      status: ['Active'],
    });
  }

  onFocus(field: string) {
    this.focusedField = field;
  }

  onBlur() {
    this.focusedField = null;
  }

  initEditUserForm() {
    this.editUserForm = this.fb.group(
      {
        id: [''],
        userRoleId: [''],
        name: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        password: [''],
        phone: ['', Validators.required],
        status: ['Active', Validators.required],
      }
    )
  }
  userName:any = []
  loadUsers() {
    this.userManagement.loadUserData().subscribe((response) => {
      if(response['masteruser'].length){
        this.masterUsers = response['masteruser'];
      }  
   else{
    this.masterUsers.push(response['masteruser']);
    }
        this.masterUsers.forEach((element,i) => {
          element.customIndex = i;
          element.customer.color = this.colorPicker(element.lastLogin);
      });
      this.masterUsersCopy = JSON.parse(JSON.stringify(this.masterUsers))
      console.log("masteruser : ", this.masterUsers);
      let currentUser = JSON.parse(localStorage.getItem('currentUser'));
      const result = Array.isArray(response['masteruser']);
      if(!result)
      {
        this.enableCreateUser = true;
        this.enableEditUser = true;
      }
      else{
        this.masterUsers.forEach(element => {
          if(element.customer.userRoleId == currentUser.userRoleId)
          {
            if(element.userRole)
            {
              this.enableCreateUser = element.userRole.CustomerProfile.privilegeMap.entry[0].value.createPrivilege.value == 'YES' ? true : false;
              this.enableEditUser = element.userRole.CustomerProfile.privilegeMap.entry[0].value.editPrivilege.value == 'YES' ? true : false;
            }
          }
        });
      }

    })
  }

  loadProjects(selectedUser) {
    this.searchProject = undefined;
    this.editProjectAccessList = [];
    this.userManagement.getProjectInfo().subscribe((response) => {
      this.projectList = response;
       this.projectList.forEach(element => {
           element['view'] = false;
           element['edit'] = false;
           element['delete'] = false;
           element['execute'] = false;
       });
      this.loadUserRestrictions(selectedUser);
    })
  }
  testAccess = []
  //component/account/management/user/{userId}
 
  loadRc(user){
    this.userData = user
    this.project.loadAccess(this.userData['customer'].id).subscribe((res: any) => {
      if (res) {
        console.log('componentRC',res);
        this.allComponent = res;
        this.allComponent.forEach((element,i) => {
          element.rcIndex = i;
        });
        this.allComponentCopy = JSON.parse(JSON.stringify(this.allComponent));
      }
    })
  }
  
  loadwf(user){
    this.userData = user
    
    // this.project.loadWorkflow(this.userData['customer'].id).subscribe((res: any) => {
    //   if (res) {
    //     console.log('componentRC',res);
    //     this.workFlowList = res;
       
    //   }
    // })

    this.project.getWflist(this.userData['customer'].id).subscribe(
      (res:any)=>{
        this.workFlowList = res
       console.log('restriction',res)
      //   this.workFlowList.forEach(element => {
      //     element['view'] = false;
      //     element['edit'] = false;
      //     element['disabled'] = false;
      //     element['execute'] = false;
      // });
       
      //   this.loadwfRestriction(user)
        
      }
    )
  }
loadwfRestriction(selectedUser){
  this.selectedUserId = selectedUser['customer'].id;

  this.project.getPermissionWorkFlow().subscribe((response:any)=>
    {
      console.log('response',response);
    var restrictedWf = response.filter((f:any)=>f.userId==this.selectedUserId)
    console.log('test1',restrictedWf);
    
      this.oldUser = false;
      if(response)
      {
        restrictedWf.forEach(element => {
              this.workFlowList.forEach(data => {
                  if(element.workflowId== data.id)
                  {
                    data['view'] =element['view'];
                    data['edit'] = element['edit'];
                    data['disabled'] = element['disabled'];
                    data['execute'] = element['execute'];
                    data['workflowId'] = element['workflowId']
                    
                    
                  }
              });
              // console.log('testWF',this.workFlowList);
              
          });

         // check if multiSelect is on or not 
      

        
      }
     
    
    }) 
}

  loadUserRestrictions(selectedUser)
  {
    this.selectedUserId = selectedUser['customer'].id;
    
    let booleanMap = { "true" : true , "false" :  false};
    this.userManagement.getUserRestrictions(this.selectedUserId).subscribe((response:any)=>
    {
      this.oldUser = false;
      if(response)
      {
          response.forEach(element => {
              this.projectList.forEach(data => {
                  if(element.entityId == data.id)
                  {
                    data['view'] =element['view'];
                    data['edit'] = element['edit'];
                    data['delete'] = element['delete'];
                    data['execute'] = element['execute'];
                    data['id'] =  element['id'];
                    if(element['entityId'])
                    {
                        data['entityId'] = element['entityId'];
                    }
                    
                  }
              });
          });

         // check if multiSelect is on or not 
         this.projectList.forEach((project)=>
        {
          if (!project.view) {
            this.selectAllView = false;
          }
          if (!project.edit) {
            this.selectAllEdit = false;
          }
          if (!project.delete) {
            this.selectAllDelete = false;
          }
          if (!project.execute) {
            this.selectAllExecute = false;
          }
        })

        if(this.projectList.length == 0)
        {
          this.selectAllView = false;
          this.selectAllEdit = false;
          this.selectAllDelete = false;
          this.selectAllExecute = false;
          return;
        }
      }
      else
      {
          this.oldUser = true;
      }
    //  console.log(this.projectList);
      this.loadProjectList = true;
    })
  }

  addUser() {
    if (this.addUserForm.invalid) {
      this.toastrService.clear();
      this.toastrService.warning("Please fill the form and try again");
      return;
    }

    if (!this.isValidEmail(this.addUserForm.value.email)) {
      this.toastrService.clear();
      this.toastrService.warning("Invalid email");
      return;
    }

    if(this.addUserForm.value.phone.toString().length > 10)
    {
      this.toastrService.clear();
      this.toastrService.warning("Phone number can't exceed 10 digits");
      return;
    }

    this.userManagement.createCustomer(this.addUserForm.value).subscribe((data) => {
      this.loadUsers();
      this.toastrService.clear();
      this.toastrService.success("User created successfully");
      this.initAddUserForm();
      this.closeAddUserForm.nativeElement.click();
    })
  }

  editUser(index) {
    // this.masterUsers.forEach((element ,i)=> {
    //   element.customIndex = i;
    //   // this.userName.push(element.customer.name)
    // });
    this.editUserIndex = index
    let customer = this.masterUsersCopy[index];
    this.editUserForm.patchValue({
      id: customer['customer'].id,
      userRoleId: customer['customer'].userRoleId,
      name: customer['customer'].name,
      email: customer['customer'].email,
      password: null,
      phone: customer['customer'].phone,
      status: customer['customer'].status
    })
    this.showEditForm = true;
  }

  updateUser() {
    if (this.editUserForm.invalid) {
      if(this.editUserForm.controls.email.invalid)
      {
        this.toastrService.clear();
        this.toastrService.error("Invalid email");
      }
      else
      {
        this.toastrService.clear();
        this.toastrService.warning("Please fill the form and try again");
      }
      return;
    }
    this.editUserIndex = null;
    let obj = this.editUserForm.value;
    if (obj.password == null) {
      delete obj.password;
    }

    this.userManagement.editCustomer(obj).subscribe((data) => {
      this.showEditForm = false;
      this.toastrService.clear();
      this.toastrService.success("User updated successfully");
      this.loadUsers();
    })
  }

  selectProfile(index) {
    this.selectedProfile = this.masterUsers[index];
    this.userManagementData = {};
    this.selectedProfile.userRole.CustomerProfile.privilegeMap.entry.forEach(element => {
      console.log("entry : ", this.selectedProfile);
      if (element.key == "USER") {
        let keys = Object.keys(element.value);
        keys.forEach((data) => {
          if (element.value[data].value) {
            if (element.value[data].value == "DISABLE") {
              element.value[data].value = false;
            }
            else if (element.value[data].value == "YES") {
              element.value[data].value = true;
            }
            else if (element.value[data].value == "NO") {
              element.value[data].value = false;
            }
            this.mapSelectedUserMgnt();
          }
          else {
            return;
          }
        })
      }
      else if (element.key == "PROJECT") {
        let keys = Object.keys(element.value);
        keys.forEach((data) => {
          if (element.value[data].value) {
            if (element.value[data].value == "DISABLE") {
              element.value[data].value = false;
            }
            else if (element.value[data].value == "YES") {
              element.value[data].value = true;
            }
            else if (element.value[data].value == "NO") {
              element.value[data].value = false;
            }
            this.mapSelectedUserMgnt();
          }
          else {
            return;
          }
        })
      }
    });
  }

  mapSelectedUserMgnt()
  {
    this.selectedProfile.userRole.CustomerProfile.privilegeMap.entry.forEach(element => {
      if (element.key == "USER") {
        let keys = Object.keys(element.value);
        keys.forEach((data) => {
          if (element.value[data]) {
            let userMangementMap = {createPrivilege : 'userCreatePrivilege', editPrivilege: 'userEditPrivilege', viewPrivilege: 'userViewPrivilege', maxCreationCount : 'userMaxCreationCount',workflowPrivilege : 'userWorkflowPrivilege'};
            let userMngList = ['createPrivilege', 'editPrivilege', 'viewPrivilege', 'maxCreationCount','workflowPrivilege'];
            userMngList.forEach((value)=>
            {
              this.userManagementData[userMangementMap[value]] = JSON.parse(JSON.stringify(element.value[value]));
            })
            console.log(this.userManagementData);
          }
          else {
            return;
          }
        })
      }
      else if (element.key == "PROJECT") {
        let keys = Object.keys(element.value);
        keys.forEach((data) => {
          if (element.value[data]) {
            let automationMangementMap = {createPrivilege : 'automationCreatePrivilege', maxCreationCount : 'automationMaxCreationCount'};
            let automationMngList = ['createPrivilege', 'maxCreationCount'];
            automationMngList.forEach((value)=>
            {
              this.userManagementData[automationMangementMap[value]] = JSON.parse(JSON.stringify(element.value[value]));
            })
            this.userManagementData.userViewPrivilege.value=true;
            console.log(this.userManagementData);
          }
          else {
            return;
          }
        })
      }
    });
  }

  mapOpposite()
  {
    this.selectedProfile.userRole.CustomerProfile.privilegeMap.entry.forEach(element => {
      if (element.key == "USER") {
        let keys = Object.keys(element.value);
        let userMangementMap = {createPrivilege : 'userCreatePrivilege', editPrivilege: 'userEditPrivilege', viewPrivilege: 'userViewPrivilege', maxCreationCount : 'userMaxCreationCount',workflowPrivilege : 'userWorkflowPrivilege'};
        keys.forEach((data) => {
          if (data == 'createPrivilege') {
            element.value[data].value = JSON.parse(JSON.stringify(this.userManagementData[userMangementMap['createPrivilege']].value))
          }
          else if (data == 'editPrivilege') {
            element.value[data].value = JSON.parse(JSON.stringify(this.userManagementData[userMangementMap['editPrivilege']].value))
          }
          else if (data == 'viewPrivilege') {
            this.userManagementData[userMangementMap['viewPrivilege']].value=
            element.value[data].value = JSON.parse(JSON.stringify(this.userManagementData[userMangementMap['viewPrivilege']].value))
          }
          else if(data == 'maxCreationCount'){
            element.value[data] = JSON.parse(JSON.stringify(this.userManagementData[userMangementMap['maxCreationCount']]))
          }
          else if(data == 'workflowPrivilege'){
            element.value[data].value = JSON.parse(JSON.stringify(this.userManagementData[userMangementMap['workflowPrivilege']].value))
          }
        })
      }
      else if (element.key == "PROJECT") {
        let keys = Object.keys(element.value);
        let automationMangementMap = {createPrivilege : 'automationCreatePrivilege', maxCreationCount : 'automationMaxCreationCount'};
        keys.forEach((data) => {
          if (data == 'createPrivilege') {
            element.value[data].value = JSON.parse(JSON.stringify(this.userManagementData[automationMangementMap['createPrivilege']].value))
          }
          else if (data == 'maxCreationCount') {
            element.value[data] = JSON.parse(JSON.stringify(this.userManagementData[automationMangementMap['maxCreationCount']]))
          }
        })
      }
    });
    console.log("before making API call : ", this.selectedProfile, this.userManagementData);
    this.updateUserAccess();
  }

  updateUserAccess() {

    this.selectedProfile.userRole.CustomerProfile.privilegeMap.entry.forEach(element => {
      if (element.key == "USER") {
        let keys = Object.keys(element.value);
        keys.forEach((data) => {
          if (element.value[data].value != undefined) {
            if (element.value[data].value == "DISABLE") {
              return;
            }
            else if (element.value[data].value) {
              element.value[data].value = "YES";
            }
            else if (element.value[data].value == false) {
              element.value[data].value = "NO";
            }
          }
          else {
            return;
          }
        })
      }
      else if (element.key == "PROJECT") {
        let keys = Object.keys(element.value);
        keys.forEach((data) => {
          if (element.value[data].value != undefined) {
            if (element.value[data].value == "DISABLE") {
              return;
            }
            else if (element.value[data].value) {
              element.value[data].value = "YES";
            }
            else if (element.value[data].value == false) {
              element.value[data].value = "NO";
            }
          }
          else {
            return;
          }
        })
      }
    });
    this.userManagement.editCustomerProfile(this.selectedProfile).subscribe((response) => {
      this.toastrService.clear();
      this.toastrService.success("User updated successfully");
      this.loadUsers();
      this.closeUserAccessForm.nativeElement.click();
    })
  }

  multiSelectAcess(event, type)
  {
    this.projectList.forEach((project: any) => {
      project[type] = event;
      switch(type)
      {
        case 'view':
          this.selectAllView = event;
          break;
        case 'delete':
          this.selectAllDelete = event;
          break;
        case 'edit':
          this.selectAllEdit = event;
          break;
        case 'execute':
          this.selectAllExecute = event;
          break;
        default:
          console.error("Type not found");
          break;
      }
      if(type != 'view' && event)
      {
        project['view'] = true;
        this.selectAllView =  true;
      }
      else if(type == 'view' && !event)
      {
        project['view'] = false;
        project['delete'] = false;
        project['edit'] = false;
        project['execute'] = false;
        this.selectAllView =  false;
        this.selectAllEdit =  false;
        this.selectAllDelete =  false;
        this.selectAllExecute =  false;
      }
      project['userId'] = this.selectedUserId;
      this.editProjectAccessList.push(project);
    });

  }

  updateAccess(event, index, type) {
    switch (type) {
      case 'view':
        this.projectList[index]['view'] = event;
        if (!event) {
          this.projectList[index]['delete'] = event;
          this.projectList[index]['edit'] = event;
          this.projectList[index]['execute'] = event;
        }

        break;
      case 'delete':
        this.projectList[index]['delete'] = event;
        if (event) {
          this.projectList[index]['view'] = event;
        }
        break;
      case 'edit':
        this.projectList[index]['edit'] = event;
        if (event) {
          this.projectList[index]['view'] = event;
        }
        break;
      case 'execute':
        this.projectList[index]['execute'] = event;
        if (event) {
          this.projectList[index]['view'] = event;
        }
        break;
      default:
        break;
    }



    let selectedProject = JSON.parse(JSON.stringify(this.projectList[index]));
    selectedProject['userId'] = this.selectedUserId;

    let projectIndex: number;
    let projectExist: boolean;
    this.editProjectAccessList.forEach((element, i) => {
      if (element.id == selectedProject.id) {
        projectIndex = i;
        projectExist = true;
      }
    })

    if (projectExist) {
      this.editProjectAccessList[projectIndex] = selectedProject;
    }
    else {
      this.editProjectAccessList.push(selectedProject);
    }

   // console.log(this.editProjectAccessList, selectedProject);
    
  }
 compObj = {
  "componentId": '',
  "view": false,
  "edit": false,
  "delete": false,
  "desabled": false
}

  updateRcAccess(event, index, type) {
    switch (type) {
      case 'view':
        this.allComponent[index]['view'] = event;
        // this.allComponentCopy[index]['componentId'] = id 
        if (!event) {
          this.allComponent[index]['delete'] = event;
          this.allComponent[index]['edit'] = event;
          // this.testAccess[index]['execute'] = event;
        }

        break;
      case 'delete':
        this.allComponent[index]['delete'] = event;
        // this.allComponentCopy[index]['componentId'] = id
        if (event) {
          this.allComponent[index]['view'] = event;
        }
        break;
      case 'edit':
        this.allComponent[index]['edit'] = event;
        // this.allComponentCopy[index]['componentId'] = id
        if (event) {
          this.allComponent[index]['view'] = event;
        }
        break;
      default:
        break;
    }
  
  this.allComponent.forEach(element => {
    delete element.id, element.sharedName, element.userId;
  });
 
  this.testpermissionBody.componentRestriction = this.allComponent;
  console.log(this.testpermissionBody);
  //  this.project.updateRcAccess(this.userData['customer'].id, this.testpermissionBody).subscribe(
  //   (res:any)=>{
  //        console.log(res, 'Rc');
         
  //   }
  //  )
    
  }

  updateRcPermission(){
    this.project.updateRcAccess(this.userData['customer'].id, this.testpermissionBody).subscribe(
      (res:any)=>{
           console.log(res, 'Rc');
           this.cancelRcAccess.nativeElement.click();
           this.toastrService.clear();
           this.toastrService.success('Access permissions have been successfully updated for the user.');
           
      }
     )
      
  }
 
  wfAccessBody = {
    "workflowUserRestrictions":[]
}
  updatewfAccess(event, index, type) {
    switch (type) {
      case 'view':
        if(event){
        this.workFlowList[index]['view'] = event;
        // this.allComponentCopy[index]['componentId'] = id 
        this.workFlowList.forEach(element => {
          if(element.view==false){
            this.selectAllViewwf =  false;
          }
       
        });
      }
        if (!event) {
          this.workFlowList[index]['disabled'] = event;
          this.workFlowList[index]['edit'] = event;
          this.workFlowList[index]['execute'] = event;
          this.selectAllViewwf =  false;
          
          
        }

        break;
      case 'delete':
        this.workFlowList[index]['disabled'] = event;
        // this.allComponentCopy[index]['componentId'] = id
       
        if (event) {
          this.workFlowList[index]['view'] = event;
          this.workFlowList.forEach(element => {
            if(element.disabled==true){
              this.selectAllDeletewf =  event;
            }
           
          });
        }
        if(!event){
          
          this.selectAllDeletewf =  false;
          
        }
        break;
      case 'edit':
        this.workFlowList[index]['edit'] = event;
        // this.allComponentCopy[index]['componentId'] = id
        if (event) {
          this.workFlowList[index]['view'] = event;
          this.workFlowList.forEach(element => {
            if(element.edit==true){
              this.selectAllEditwf =  event;
            }
          
          });
          
        }
        if(!event){
          this.selectAllEditwf =  false;
         
        }
        break;
        case 'execute':
        this.workFlowList[index]['execute'] = event;
        if (event) {
          this.workFlowList[index]['view'] = event;
          this.workFlowList.forEach(element => {
            if(element.execute==true){
              this.selectAllExecutewf =  event;
            }
          
          });
        }
        if(!event){
          this.selectAllExecutewf =  false;
        }
        break;
      default:
        break;
    }
  
  // this.allComponent.forEach(element => {
  //   delete element.id, element.sharedName, element.userId;
  // });
  this.wfAccessBodyCopy =  JSON.parse(JSON.stringify(this.workFlowList));
  const filteredData = this.wfAccessBodyCopy.map(item => ({
    workflowId: item.workflowId,
    workflowName: item.workflowName,
    view: item.view,
    edit: item.edit,
    execute:item.execute,
    disabled: item.disabled
}));
console.log(filteredData);
  this.wfAccessBody.workflowUserRestrictions = filteredData;
  
  
  //  this.project.updateRcAccess(this.userData['customer'].id, this.testpermissionBody).subscribe(
  //   (res:any)=>{
  //        console.log(res, 'Rc');
         
  //   }
  //  )
    
  }
  multiWfSelectAcess(event, type)
  {
    this.workFlowList.forEach((wf: any) => {
      wf[type] = event;
      switch(type)
      {
        case 'view':
          this.selectAllViewwf = event;
          break;
        case 'disabled':
          this.selectAllDeletewf = event;
          break;
        case 'edit':
          this.selectAllEditwf = event;
          break;
        case 'execute':
          this.selectAllExecutewf = event;
          break;
        default:
          console.error("Type not found");
          break;
      }
      if(type != 'view' && event)
      {
        wf['view'] = true;
        this.selectAllViewwf =  true;
      }
      else if(type == 'view' && !event)
      {
        wf['view'] = false;
        wf['disabled'] = false;
        wf['edit'] = false;
        wf['execute'] = false;
        this.selectAllViewwf =  false;
        this.selectAllEditwf =  false;
        this.selectAllDeletewf =  false;
        this.selectAllExecutewf =  false;
      }
      // project['userId'] = this.selectedUserId;
      // this.editProjectAccessList.push(project);
      
  this.wfAccessBodyCopy =  JSON.parse(JSON.stringify(this.workFlowList));
  const filteredData = this.wfAccessBodyCopy.map(item => ({
    workflowId: item.workflowId,
    workflowName: item.workflowName,
    view: item.view,
    edit: item.edit,
    execute:item.execute,
    disabled: item.disabled
}));
console.log(filteredData);
  this.wfAccessBody.workflowUserRestrictions = filteredData;
    });

  }
  updatewfPermission(){
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
//const dogPerson = pick(person, 'name', 'dog');
    //  this.wfAccessBodyCopy =  JSON.parse(JSON.stringify(this.workFlowList));

    this.project.updateWorkFlow(this.userData['customer'].id, this.wfAccessBody).subscribe(
      (res:any)=>{
           console.log(res, 'wf');
           this.cancelwfAccess.nativeElement.click();
           this.toastrService.clear();
           this.toastrService.success('Access permissions have been successfully updated for the user.');
           
      }
     )
      
  }
  testpermissionBody = {
    "componentRestriction": []
  }
  updateProjectManagement()
  {
    let body = JSON.parse(JSON.stringify(this.editProjectAccessList))
    body.forEach(element => {
 
        if(this.oldUser || element['entityId'] == undefined)
        {
          element['entityId'] =  element['id'];
          delete element['id'];
        }

        if(element['entityId'] == element['id'])
        {
          delete element['id'];
        }
        
    });
    let obj = {
      userRestriction : body
    }
    this.userManagement.updateAccessManagement(obj).subscribe((response)=>
    {
      this.toastrService.success('User Automation Permission Updated Successfully');
      this.cancelprojectAccess.nativeElement.click();
    })
  }

  colorPicker(number)
  {
    console.log(number);
    let value = 'green';
    if(number == 0)
    {
      value =  'green';
    }

    else if(number == -1)
    {
       value = 'blue';
    }

    else if(number > 0 && number <=3)
    {
      value = 'yellow';
    }
    // else if(number > 3 && number <7)
    // {
    //   value = 'orange';
    // }
    else
    {
      value = 'red';
    }
    return value;
  }
  onSortClick(event) {
    let target = event.currentTarget,
      classList = target.classList;

    if (classList.contains('fa-angle-up')) {
      classList.remove('fa-angle-up');
      classList.add('fa-angle-down');
      this.sortDir=-1;
    } else {
      classList.add('fa-angle-up');
      classList.remove('fa-angle-down');
      this.sortDir=1;
    }
    this.sortArr('name');
  }
  sortArr(colName:any){
    this.masterUsers.sort((a,b)=>{
      a= a['customer'][colName].toLowerCase();
      b= b['customer'][colName].toLowerCase();
      
      return a.localeCompare(b) * this.sortDir;
    });
  }
  showTooltip(event, user)
  {
    console.log(user);
    const targetElement = event.target as HTMLElement;
    const classNames = targetElement.className;
    console.log(classNames);

    let tooltipText = '';

    if (targetElement.classList.contains('darkBlue')) {
      tooltipText = 'New account';
    } else if (targetElement.classList.contains('green')) {
      tooltipText = 'Active today';
    } else if (targetElement.classList.contains('yellow')) {
      tooltipText = `Active ${user.lastLogin} day(s) ago`;
    } else if (targetElement.classList.contains('orange')) {
      tooltipText = `Active ${user.lastLogin} day(s) ago`;
    } else if (targetElement.classList.contains('red')) {
      tooltipText = `Active ${user.lastLogin} day(s) ago`;
    }

    if (tooltipText) {
      targetElement.setAttribute('title', tooltipText);
    }

  }

getUserState(count){
if(count<10){
  return true
}
else{
  return false
}
}

isValidEmail(email: string): boolean {
  const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  return emailPattern.test(email);
}

filterUser()
{
  let userCopy = JSON.parse(JSON.stringify(this.masterUsersCopy));
  if(userCopy.length == 0)
  {
    return;
  }
 this.masterUsers =  userCopy.filter(user => {
      let emailId =  user.customer.email.toLowerCase();
      if(emailId.includes(this.searchString.toLowerCase()))
      {
        return true;
      }
  });

}
filterWf()
{
  let workFlowListCopy = JSON.parse(JSON.stringify(this.workFlowList));
  if(this.searchWf.length == 0)
    {
      this.workFlowList = workFlowListCopy;
    }
  console.log(this.searchWf);
  
  
  this.workFlowList = this.workFlowList.filter((f:any)=>f.name.includes(this.searchWf))
      
 console.log(this.workFlowList);
 

}
loadfeatureflag(){
  this.project.loadFeatureFlag().subscribe(
    (data:any)=>{
      this.enablewf = data[0].enabled;
    }
  )
}
}

